module.exports = __webpack_public_path__ + "img/cpDeviceManage.5c9d4c03.svg";